module.exports = __webpack_public_path__ + "img/watch_offline.0bfa6af5.svg";